export default __webpack_public_path__ + "static/media/hello.3e9463d0.svg";